import { useCallback, useEffect, useState } from "react";
import VideoConfigCard, {
  VideoConfigCardContainer,
  VideoConfigCardHeader,
} from "../UIComponents/VideoConfigCard/VideoConfigCard";
import ChoseActionBar from "./ChoseActionBar/ChoseActionBar";
import CoverImgGroup from "../Components/CoverImgGroup/CoverImgGroup";
import {
  bindingDecoration,
  deleteDecoration,
  getBindDecoration,
  getCoverList,
} from "@/services/mixCutDetail/mixCutDetail";
import useCoverAndBg from "@/useStore/mixCutDetail/useCoverAndBg";
import { observer } from "mobx-react";
import useRequest from "@/requestHooks/mixCutDetail/useRequest";
import MaterialFileModal from "@/components/business/MaterialFileModal/MaterialFIleModal";
import { toJS } from "mobx";
import allowTypeStore from "@/stores/allowTypeStore";
import { useParams } from "react-router-dom";
import TitleGroup from "../FontTitle/TitleGroup/TitleGroup";
import SelfDecorationGroup from "./SelfDecorationGroup";
import { Message } from "@arco-design/web-react";
import "./VideoCoverConfig.less";
import { IMaterialDetail } from "@/services/createSpace/graphQ/getSimpleMedia";
import ChoseDetailPopover from "./ChoseDetailPopover/ChoseDetailPopover";
import CommonUpload from "@/components/business/CommonUpload";
import usePreviewConfig from "@/useStore/preview/usePreview";
import ConfigStore from '@/stores/mixedConfig/index'
import useMixCutDetailMsg from "@/useStore/mixCutDetail/useMixCutDetailMsg";
export interface IDecorationConfig {
  title: any;
  style?: React.CSSProperties;
}
import { getScale } from './enum'

const DecorationConfig: React.FC<IDecorationConfig> = observer((props) => {
  const { title, style } = props;
  const { id } = useParams();
  const { decorations, handleDecorationChange } = useCoverAndBg();
  const { data } = useRequest({ request: getCoverList });
  const [uploadVisible, setUploadVisible] = useState(false);
  const [selfCoverData, setSelfCoverData] = useState([]);
  const [titleGroupIndex, setTitleGroupIndex] = useState(0);
  const { handleClipIdChange } = usePreviewConfig();
  const [checkedId, setCheckedId] = useState(null)
  const { mixCutDetailMsg } = useMixCutDetailMsg();
  const toSelfCoverDataGetItem = (id: number | string) => {
    const item = selfCoverData.find((item) => item.id === id);
    return item;
  };

  const toPublicDataGetItem = (id: number | string) => {
    const item = data.find((item) => Number(item.id) === id);
    return item;
  };

  useEffect(() => {
    if (decorations && decorations?.length > 0) {
      setTimeout(() => {
        handleClipIdChange(decorations[decorations.length - 1].id);
      }, 1000);
    }
  }, [decorations]);

  const handleImgCoverCardCheckStateChange = (e: boolean, id: string | number, media_id?: string) => {
    if (!data || data.length === 0) return;
    if (e) {
      const item =
        titleGroupIndex === 1
          ? toPublicDataGetItem(id)
          : toSelfCoverDataGetItem(id);
      let newArr = []
      const sh = getScale(item.width, item.height, mixCutDetailMsg.aspect)
      if (decorations && decorations.length > 0) {
        newArr = [...decorations, {
          id: Math.floor(Date.now() + Math.random() * 10000),
          material: {
            media_id: item.media_id,
            url: item.play_info.cover_url,
          },
          settings: {
            x: 0,
            y: 0,
            real_width: item.width,
            real_height: item.height,
            width: 0.5, //[0～0.9999]时，表示相对输出视频宽的占比。>=2时，表示像素。
            height: sh,
            opacity: 1
          }
        }]
      } else {
        newArr = [
          {
            id: Math.floor(Date.now() + Math.random() * 10000),
            material: {
              media_id: item.media_id,
              url: item.play_info.cover_url,
            },
            settings: {
              x: 0,
              y: 0,
              width:0.5, //[0～0.9999]时，表示相对输出视频宽的占比。>=2时，表示像素。
              height: sh,
              opacity: 1,
              real_width: item.width,
              real_height: item.height,
            }
          }
        ]
      }
      handleDecorationChange(newArr);
    } else {
      console.log(decorations, 'decorations', id)
      handleDecorationChange(decorations.filter((item) => item.material.media_id !== media_id));
    }
  };

  const init = async () => {
    const selfCover = await getBindDecoration(id);
    setSelfCoverData(selfCover);
  };
  useEffect(() => {
    init();
  }, []);

  const handleMaterialFileModalOkClick = async (e: IMaterialDetail[]) => {
    if (e.length > 0) {
      console.log(e, 'e')
      let getUnBindIds = []
      try {
        if (decorations && decorations.length > 0) {
          getUnBindIds = e.filter(
            (item) =>
              decorations.findIndex((step) => Number(step.material.media_id) === Number(item.id)) < 0,
          );
        } else {
          getUnBindIds = e
        }
        await bindingDecoration(
          id,
          getUnBindIds.map((item) => Number(item.id)),
        );
        const selfCover = await getBindDecoration(id);
        setSelfCoverData(selfCover);
        setUploadVisible(false);
      } catch (e) {
        console.log(e);
        // Message.error("添加失败，请刷新后重试！");
      }
    }
  };

  const deleteSelfCover = async (e: number, media_id: string) => {
    try {
      await deleteDecoration(id, e);
      const selfCover = await getBindDecoration(id);
      setSelfCoverData(selfCover);
      Message.success("删除自定义贴纸成功!");
      handleDecorationChange(decorations.filter((item) => item.material.media_id !== media_id));
    } catch (e) {
      console.log(e);
      Message.error("删除失败！");
    }
  };

  const handleLookBtnClick = (id: string) => {
    const item = decorations.find((item) => item.material.media_id === id);
    if (item) {
      handleClipIdChange(item.id);
    }
  }

  return (
    <VideoConfigCard style={style}>
      <VideoConfigCardHeader
        headerLeft={title}
        headerRight={
         <>
           <ChoseDetailPopover
             selfCoverData={selfCoverData}
             handleTagCloseBtnClick={(e, id, media_id) => {
               handleImgCoverCardCheckStateChange(false, null, media_id)
             }}
             handleClearBtnClick={() => {
               handleDecorationChange([]);
             }}
             data={decorations}
             title={"封面配置"}
           />
         </>
        }
      />
      <VideoConfigCardContainer>
        <>
          <div className="chose-action-bar">
            <TitleGroup
              handleActiveIndexChange={(e) => {
                setTitleGroupIndex(e);
              }}
              // data={[{ title: "官方封面图" }, { title: "自定义" }]}
              data={[{title: "自定义"}]}
              active={titleGroupIndex} />
          </div>
          {titleGroupIndex === 1 ? (
            <CoverImgGroup
              coverList={data}
              handleChoseImgChange={(state, id) => {
                handleImgCoverCardCheckStateChange(state, id);
              }}
              collection={[]}
            />
          ) : (
            <>
              <SelfDecorationGroup
                handleLookBtnClick={(id) => {
                  handleLookBtnClick(id)
                }}
                emitChange={(data) => {
                  setSelfCoverData(data);
                  const sortOrder = data.map((item) => item.media_id);
                  // 创建映射，将 media_id 映射到排序索引
                  const orderMapping = {};
                  sortOrder.forEach((media_id, index) => {
                    orderMapping[media_id] = index;
                  });
                  // 根据映射排序
                  ConfigStore.global_settings.decorations = ConfigStore.global_settings.decorations.sort((a, b) => {
                    const indexA = orderMapping[a.material.media_id];
                    const indexB = orderMapping[b.material.media_id];
                    return indexA - indexB;
                  });
                  handleDecorationChange(ConfigStore.global_settings.decorations);
                  setTimeout(() => {
                    handleClipIdChange(decorations[0].id);
                  }, 1000)
                }}
                handleDeleteItem={(e, media_id) => {
                  deleteSelfCover(e, media_id);
                }}
                handleUploadBlockBtnClick={() => {
                  setUploadVisible(true);
                }}
                handleChoseImgChange={(state, id, media_id) => {
                  handleImgCoverCardCheckStateChange(state,id,media_id);
                }}
                data={selfCoverData}
                collection={decorations}
              />
            </>
          )}
        </>
      </VideoConfigCardContainer>
      {uploadVisible ? (
        <CommonUpload
          showAddFile={false}
          defalutValue={'material'}
          handleOkBtnClick={(e) => {
            handleMaterialFileModalOkClick(e);
          }}
          maxCollectionLength={15}
          onCancel={() => {
            setUploadVisible(false);
          }}
          defaultCollection={
            decorations?.length > 0 ? decorations
              .filter((item) => (item as any).play_info)
              .map((item) => item.id) as any : []
          }
          importCollection={selfCoverData?.length > 0 && selfCoverData.map(item => item.id)}
          visible={uploadVisible}
          allowMetarial={[3, 4]}
          allowType={toJS(
            allowTypeStore.getAllPictureTypeString(),
          )}></CommonUpload>
      ) : (
        <></>
      )}
    </VideoConfigCard>
  );
});
export default DecorationConfig;
